import '../../core/components/app-root/AppRoot.css';
import '../../styles/field.css';
import './ChipDeleteButton.css';
export var base = '_3mvhm30-3-8-0';
export var disabledOverride = '_3mvhm32-3-8-0';
export var neutralEmphasizedOverride = '_3mvhm31-3-8-0';
export var size = {'default':'_3mvhm33-3-8-0',condensed:'_3mvhm34-3-8-0'};